import { neowiseFormikField } from './neowiseFormikField';

export const FmkRange = neowiseFormikField('nw-range');
